import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";

const API_URL = API.API_URL;

@Injectable()
export class DataStoreService {
  private _dataStoreURL = API_URL + "/datastore";

  constructor(private httpManager: HttpManager) { }

  getOrgTransactions(orgID: number, range: number): Observable<any> {
    return this.httpManager.httpGet<any>(`${this._dataStoreURL}/orgtransactions/${orgID}/${range}`);
  }

  getUserCertificates(userFirstName: string, userLastName: string, searchOrganization: number): Observable<any> {
    return this.httpManager.httpGet<any>(
      `${this._dataStoreURL}/usercecompletion/${userFirstName}/${userLastName}/${searchOrganization}/1/100`
    );
  }

  getUserCompletions(userFirstName: string, userLastName: string, searchOrganization: number): Observable<any> {
    return this.httpManager.httpGet<any>(
      `${this._dataStoreURL}/usercompletion/${userFirstName}/${userLastName}/${searchOrganization}/1/10000`
    );
  }
}
